<template>
  <section>
    <div class="container">
      <div class="row">
        <div v-if="isLoaded && (!activities || activities.length === 0)" style="display:flex;justify-content:center;align-items:center;height:180px;width:100%;font-weight:bold;font-size:1.2em;text-align:center;">
          활동이 없습니다.
        </div>
  <div class="col-md-6" v-else v-for="activity in activities" style="margin-bottom: 10px;">
          <div class="card h-100">
            <router-link :to="{name : 'activitySearch', params : { size:'10', page:'0', category:activity.category, query:`category:${activity.category}` }}" >
              <span class="notify-badge" :style="'background-color:'+activity.categoryColor">{{activity.categoryName}}</span><img class="card-img-top" :src="activity.thumbnail" alt="">
            </router-link>
            <div class="card-body">
              <h4 class="card-title">
                <router-link :to="{name : 'activityShow', params : { id : activity.id }}">{{activity.title}}</router-link>
              </h4>
              <p class="card-text text-danger">{{activity.memberCount}}명 / {{activity.joinAblePersonCount}}명</p>
              <p class="card-text">{{activity.visibleAddressToJoinerOnly ? '신청자 공개' : activity.activityPlaceName}}</p>
              <p class="card-text">{{$root.$children[0].dateFormat(activity.activityStartDate, 'YYYY.MM.DD')}} ~ {{$root.$children[0].dateFormat(activity.activityEndDate, 'MM.DD')}}<br>
                {{$root.$children[0].dateFormat(activity.activityStartDate, 'HH:mm')}} ({{parseInt(activity.volunteerMinute/60)}}h)</p>
            </div>
            </div>
          </div>
          <hr/>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
  /* eslint-disable */
  export default {
    name: 'ActivityListWide',
    data() {
      return {
        activities : [],
        search: {},
        isLoaded: false,
      }
    },
    components: {

    },
    props: {
      page: String,
      size: String,
      target: String,
      value: String,
      category: String,
      interMemberId: Number ,
      registMemberId: Number ,
    },
    methods: {
      getInterList() {
        let me = this;
        let u = new URLSearchParams(this.search).toString();
        let url = process.env.VUE_APP_PUBLIC_API_URL + `/activity/list/member/interested/${this.$auth.user().id}?${u}`;
        this.axios.get(url)
          .then(function (res) {
            me.activities = res.data;
            me.isLoaded = true;
          }).catch(function (error) {
            me.isLoaded = true;
            console.log(error);
          });
      },
      getRegList() {
        let me = this;
        let u = new URLSearchParams(this.search).toString();
        let url = process.env.VUE_APP_PUBLIC_API_URL + `/activity/list/member/registered/${this.$auth.user().id}?${u}`;
        this.axios.get(url)
          .then(function (res) {
            me.activities = res.data;
            me.isLoaded = true;
          }).catch(function (error) {
            me.isLoaded = true;
            console.log(error);
          });
      },
    },
    watch: {
      "interMemberId" : function(val){
        this.getInterList();
      },
      "registMemberId" : function(val){
        this.getRegList();
      },
    },
    mounted() {
      //this.getList();
    },
    created() {
      //console.log(this.$route.params)
      this.search.page = !!this.$route.params.page ? this.$route.params.page : this.$props.page
      this.search.size = !!this.$route.params.size ? this.$route.params.size : this.$props.size
      this.search.query = !!this.$route.params.query ? this.$route.params.query : ''
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item {
    position:relative;
    padding-top:10px;
    display:inline-block;
  }
  .notify-badge{
    position: absolute;
    left:10px;
    top:10px;
    text-align: center;
    border-radius: 15px;
    color:white;
    padding:5px 10px;
    font-size:20px;
  }
  .no-activity-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  font-weight: bold;
  font-size: 1.1em;
  text-align: center;
}
</style>
